import { render, staticRenderFns } from "./NaverPressArticles.vue?vue&type=template&id=126e893f&scoped=true"
import script from "./NaverPressArticles.vue?vue&type=script&lang=js"
export * from "./NaverPressArticles.vue?vue&type=script&lang=js"
import style0 from "./NaverPressArticles.vue?vue&type=style&index=0&id=126e893f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e893f",
  null
  
)

export default component.exports